import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { AddPermitToDigRequest, AddPermitToDigRequestVariables } from "./__generated__/AddPermitToDigRequest";

const ADD_PERMIT_REQUEST = gql`
  mutation AddPermitToDigRequest(
    $permitDataInput: PermitDataInput
    $number: Int!
    $permitRegisterId: String!
    $sourceId: String
    $documentIds: [String!]
    $calibrationCertificate: CalibrationCertificateInput
    $asBuiltRequired: Boolean!
    $areas: [AreaInput!]
    $permitAssignmentInputs: [PermitAssignmentInput!]
    $sitePhotos: [SitePhotoInput]
    $permitTypeId: String
    $fieldValues: [PermitFieldValueInput]
  ) {
    addPermitToDigRequest(
      input: {
        permitDataInput: $permitDataInput
        number: $number
        permitRegisterId: $permitRegisterId
        sourceId: $sourceId
        documentIds: $documentIds
        calibrationCertificate: $calibrationCertificate
        asBuiltRequired: $asBuiltRequired
        areas: $areas
        permitAssignmentInputs: $permitAssignmentInputs
        sitePhotos: $sitePhotos
        permitTypeId: $permitTypeId
        fieldValues: $fieldValues
      }
    ) {
      permitToDig {
        id
      }
    }
  }
`;

export function useAddPermitRequest() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    AddPermitToDigRequest,
    AddPermitToDigRequestVariables
  >(ADD_PERMIT_REQUEST, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
